import { ContentAction } from "./ContentActions";

export class ContentActionViewModel {
  constructor(private readonly actions: ContentAction[]) {}

  getActions(): ContentAction[] {
    return this.actions;
  }
}
